import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})
export class SymbolService extends ApiService {

    public getCategories() {
        return this.get(CONSTANTS.API.SYMBOLS.GET_CATEGORIES);
    }
    public getSegments() {
        return this.get(CONSTANTS.API.SYMBOLS.GET_SEGMENTS);
    }
    public getSymbols(data: any) {
        return this.getQueryParams(CONSTANTS.API.SYMBOLS.GET_SYMBOLS, data);
    }
}
